import { createContext, useContext, useState, useMemo } from 'react';
import { useGetThirdPartyApps } from '../../../data/hooks/useGetThirdPartyApps';
import { useGetInstalledApps } from '../../../data/hooks/useGetInstalledApps';
import { ShareViaWizardSteps } from '../constants';
import { DefaultSharingMethods } from '../../../constants/sharingMethods';
import { ShareViaThirdPartySettingsProvider } from './ShareViaThirdPartySettingsContext';
// @ts-expect-error no types
import { useControlsContext } from '../../shareAsset/context';
import { jsx as _jsx } from "react/jsx-runtime";
const ShareViaSettingsContext = /*#__PURE__*/createContext(undefined);
export const ShareViaSettingsProvider = ({
  children
}) => {
  const {
    data: thirdPartyApps,
    loading: loadingThirdPartyApps
  } = useGetThirdPartyApps();
  const {
    data: installedApps
  } = useGetInstalledApps();
  const {
    isEditingScheduledEmail,
    currentDialog
  } = useControlsContext();
  const [selectedApp, setSelectedApp] = useState(isEditingScheduledEmail ? currentDialog : undefined);
  const [stepIndex, setStepIndex] = useState(isEditingScheduledEmail ? ShareViaWizardSteps.configurationStep : ShareViaWizardSteps.sharingMethodStep);
  const apps = useMemo(() => {
    return [...DefaultSharingMethods, ...thirdPartyApps.reduce((acc, app) => {
      const installedAppData = installedApps.find(item => item.id === app.id);
      return installedAppData ? /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
      acc.concat([Object.assign({}, installedAppData, app)]) : acc;
    }, [])];
  }, [installedApps, thirdPartyApps]);
  const selectedAppData = useMemo(() => apps.find(item => item.id === selectedApp), [apps, selectedApp]);
  const contextValue = {
    apps,
    stepIndex,
    selectedApp,
    selectedAppData,
    setStepIndex,
    setSelectedApp,
    loadingThirdPartyApps
  };
  return /*#__PURE__*/_jsx(ShareViaSettingsContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/_jsx(ShareViaThirdPartySettingsProvider, {
      children: children
    })
  });
};
export const useShareViaSettings = () => {
  const context = useContext(ShareViaSettingsContext);
  if (context === undefined) {
    throw new Error('useShareViaSettings must be used within a ShareViaSettingsProvider');
  }
  return context;
};